<template>
  <div id="ProductsCard">
    <div
      class="card-new animatee"
      style="
                overflow: hidden;
                cursor: pointer;
                height: 350px;
                border-radius: 15px;
                width: 15rem;
                border: 1px solid #c1c2c5;
                align-items: center;
                margin-bottom: 30px;
                position: relative;
              "
    >
      <span
        @click="navigate(product.slug)"
        v-if="product.discountPercentage"
        class="dicountspan"
        >-{{ product.discountPercentage }}%</span
      >
      <div @click="navigate(product.slug)" class="img-new">
        <div class="img-div">
          <img
            width="200px"
            height="200px"
            class="card-img-new zoomIn"
            v-bind:src="
              'https://ardunic-images.s3.eu-central-1.amazonaws.com/' +
                product.images[0]
            "
          />
        </div>
      </div>
      <div @click="navigate(product.slug)" class="card-info-new">
        <div class="title-new">
          {{ product.title }}
        </div>
        <div class="price-new mt-2">
          <span
            :class="
              `price-span ${
                product.discountPercentage
                  ? 'text--decoration__line-through'
                  : ''
              }`
            "
            >{{ product.price.showPrice | toCurrency }} IQD</span
          >
          <span v-if="product.discountPercentage" class="price-span">
            {{
              (product.price.showPrice -
                product.price.showPrice * (product.discountPercentage / 100))
                | toCurrency
            }}
            IQD
          </span>
        </div>
      </div>
      <div style="position: absolute; top: 80%" class="card-buttons">
        <div style="display: flex" class="mb-2 mt-3 buttons-section">
          <button
            v-if="product.stock > 0"
            @click="addToCart(product)"
            style="
                      width: 60px;
                      background: linear-gradient(to right, #05cefc, #5659ce);
                    "
            type="button"
            class="btn btn-sm mx-1"
          >
            <img
              width="20"
              src="@/assets/svg/Ardunic Elements-171.svg"
              alt=""
            />
          </button>
          <a
            v-if="product.aboutProduct.doc"
            :href="getLink(product.aboutProduct.doc)"
            target="_blank"
            style="
                      width: 60px;
                      background: linear-gradient(to right, #f6893a, #fdbd5d);
                    "
            class="btn btn-sm mx-1"
          >
            <img
              width="20"
              src="@/assets/svg/Ardunic Elements-181.svg"
              alt=""
            />
          </a>
          <a
            v-if="product.aboutProduct.video"
            :href="getLink(product.aboutProduct.video)"
            target="_blank"
            style="
                      width: 60px;
                      background: linear-gradient(to right, #ff54af, red);
                    "
            class="btn btn-sm mx-1"
          >
            <img
              width="20"
              src="@/assets/svg/Ardunic Elements-191.svg"
              alt=""
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

import axios from "axios";

export default {
  name: "ProductsCard",
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    navigate(slug) {
      this.$router.push({ path: `/product/${slug}` });
    },
    async addToCart(product) {
      if (product.stock == 0)
        Swal.fire({
          position: "centertop-end",
          icon: "error",
          width: "20rem",
          title: "you need to select a type !",
          showConfirmButton: true,
        });
      let data = {
        productId: product._id,
        totalQuantities: 1,
        priceIds: [],
      };
      axios
        .post("https://api.ardunic.com/v1/cart", data, {
          headers: {
            access_token: localStorage.getItem("token"),
          },
        })
        .then(() => {
          Swal.fire({
            position: "top-end",
            icon: "success",
            width: "20rem",
            title: product.title + " has been added to cart",
            showConfirmButton: false,
            timer: 1500,
          });
          this.$store.dispatch("addToCardIncrease", {
            qty: 1,
            price: product.discountPercentage
              ? product.price.showPrice -
                product.price.showPrice * (product.discountPercentage / 100)
              : product.price.showPrice,
            softAdd: true,
          });
        })
        .catch((error) => {
          Swal.fire({
            position: "center",
            icon: "error",
            title: error.response.data.message,
          });
        });
    },
    getLink(link) {
      if (link.startsWith("http")) return link;
      else return `https://${link}`;
    },
  },
};
</script>

<style scoped>
.search {
  margin-top: 90px;
}
.cards-display-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.btn {
  border-radius: 15px;
}

@media (max-width: 767px) {
  #search-cards-row {
    padding: 0px;
  }
  #list-col {
    max-width: 100%;
  }
}

.filters {
  list-style: none;
  text-align: center;
}
.filters .filter-iteam {
  /* background: #c1c2c5; */
  margin: 5px;
  width: 200px;
  border-radius: 15px;
  font-size: 1.2rem;
  color: white;
}

.grey {
  background: #c1c2c5;
}

.botn {
  font-size: 20px;
  border-radius: 20px;
  outline: none;
  width: 400px;
  height: 60px;
  font-weight: bold;
}
.botn-blue {
  color: white;
  text-align: center;
  background: linear-gradient(to right, #f6893a, #fdbd5d);
}

.org {
  background: linear-gradient(right, #ff3fbb, #ff8891);
}

.blue {
  background: linear-gradient(to right, #05cefc, #5659ce);
}
.view-more {
  position: relative;
  top: -30px;
}

.filterBy {
  border-radius: 15px;
  border: 1px solid #c1c2c5;
}

#search {
  border-radius: 15px;
  border: 1px solid #c1c2c5;
  font-size: 30px;
  color: black;
}
/* .filters {
  text-align: center;
  margin: 0 auto;
} */

.card-new {
  margin-bottom: 13px;
  border-radius: 10px;
  padding: 12px 12px;
  overflow: hidden;
  box-shadow: none !important;
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.img-new {
  width: 100%;
}

.img-div {
  position: relative;
  text-align: center;
  margin-bottom: 10px;
  line-height: 0;
  width: 100%;
  overflow: hidden;
}

.card-img-new {
  max-height: 100%;
  max-width: 100%;
}

.title-new {
  height: auto;
  line-height: 18px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: black;
  font-size: 14px;
  font-weight: bold;
}

.price-new {
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.price-span {
  margin-right: 4px;
  font-size: 16px;
  font-weight: 700;
  height: 18px;
  line-height: 18px;
  color: #333;
  vertical-align: middle;
  font-weight: 700;
}

.text--decoration__line-through {
  text-decoration: line-through;
}
</style>
